//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { uid } from "quasar";
import setConditions from "@/components/Diagrams/config/set-conditions.vue";
import AQCard from "@/components/Generics/AQCard/AQCard.vue";
import AQModal from "../../../Generics/AQModal/AQModal.vue";
import AQDialog from "../../../Generics/AQDialog/AQDialog.vue";
import AQInput from "../../../Generics/AQInput/AQInput.vue";

export default {
    components: {
        AQModal,
        AQInput,
        setConditions,
        AQDialog,
        AQCard
    },
    props: {
        conditions: { type: Object, default: () => {} }
    },
    data() {
        return {
            deleteNotification: false,
            extendParent: false,
            blockConditions: {},
            conditionName: "",
            conditionDesc: "",
            showModal: true,
            hasClose: true,
            blockNameError: false,
            headerActions: [
                {
                    label: this.$t("diagrams.components.conditionalBlock.deleteBlock")
                }
            ],
            DMPickerModelProps: {
                excludeElements: {
                    type: {
                        richtext: true,
                        attachment: true
                    }
                },
                disabledElements: {
                    attr: {
                        isList: true
                    }
                },
                classesNotSelectable: true
            }
        };
    },
    computed: {
        hasPrimary() {
            const label = this.$t("generic.done");
            return { label };
        }
    },
    watch: {
        conditions: {
            handler(newValue) {
                if (newValue && Object.keys(newValue).length) {
                    this.blockConditions = newValue.conditions;
                    this.conditionName = newValue.name;
                    this.conditionDesc = newValue.description;
                }
            },
            immediate: true
        }
    },
    methods: {
        actionsDlg(event) {
            if (event === "primary") {
                const conditions = JSON.parse(JSON.stringify(this.blockConditions));
                conditions.name = this.conditionName;
                conditions.description = this.conditionDesc;
                if (this.conditions.uuid) {
                    conditions.uuid = this.conditions.uuid;
                } else {
                    conditions.uuid = uid();
                }
                if (!this.conditionName.trim()) {
                    this.blockNameError = true;
                } else {
                    this.blockNameError = false;
                    this.$emit("saveConditions", conditions);
                }
                this.$root.$emit("showCheckedSaveBtn", false);
            } else if (event === this.$t("diagrams.components.conditionalBlock.deleteBlock")) {
                this.deleteNotification = true;
            } else if (event === "close") {
                this.$emit("input", false);
            }
        },
        deleteConditionBlock() {
            this.$emit("deleteBlock", this.conditions.uuid);
        }
    }
};
